<a class="visually-hidden-focusable km-layout-pular" href="#conteudo" data-testid="layout-pular" (click)="irParaConteudo($event)">Pular para o conteúdo</a>

<div class="km-layout">
  <header class="km-layout__topbar">
    <button
      #botaoMenu
      type="button"
      class="km-layout__icone km-layout__hamburguer"
      aria-label="Abrir menu"
      aria-controls="menu-lateral"
      [attr.aria-expanded]="sidebarAberta()"
      data-testid="layout-hamburguer"
      (click)="alternarSidebar()"
    >
      <i class="bi bi-list" aria-hidden="true"></i>
    </button>
    <span class="km-layout__marca">Kali Master</span>

    <div class="km-layout__busca">
      <button
        type="button"
        class="km-layout__buscar"
        aria-haspopup="dialog"
        aria-keyshortcuts="Control+K Meta+K"
        data-testid="busca-abrir"
        (click)="busca.abrir()"
      >
        <i class="bi bi-search" aria-hidden="true"></i>
        <span>Buscar…</span>
      </button>
    </div>

    <button
      type="button"
      class="km-layout__icone"
      [attr.aria-pressed]="temaEscuro()"
      [attr.aria-label]="rotuloTema()"
      [title]="rotuloTema()"
      data-testid="layout-tema"
      (click)="tema.alternar()"
    >
      <i class="bi" [class.bi-moon-stars]="temaEscuro()" [class.bi-sun]="!temaEscuro()" aria-hidden="true"></i>
    </button>

    <div class="km-layout__usuario">
      <button
        #botaoUsuario
        type="button"
        class="km-layout__perfil"
        aria-haspopup="menu"
        aria-controls="menu-usuario"
        [attr.aria-expanded]="menuUsuarioAberto()"
        data-testid="layout-usuario-menu"
        (click)="alternarMenuUsuario()"
        (keydown)="aoTeclarBotaoUsuario($event)"
      >
        <i class="bi bi-person-circle" aria-hidden="true"></i>
        <span class="km-layout__nome" data-testid="layout-usuario">{{ usuario()?.nome }} ({{ papel() }})</span>
        <i class="bi bi-chevron-down" aria-hidden="true"></i>
      </button>
      @if (menuUsuarioAberto()) {
        <div
          #painelUsuario
          id="menu-usuario"
          class="km-layout__dropdown"
          role="menu"
          aria-label="Menu do usuário"
          (keydown)="aoTeclarMenuUsuario($event)"
        >
          <a
            role="menuitem"
            class="km-layout__opcao"
            routerLink="/conta/senha"
            data-testid="layout-senha"
            (click)="fecharMenuUsuario()"
            >Alterar senha</a
          >
          <div role="none" class="km-layout__versao" data-testid="layout-versao">v{{ versao }}</div>
          <button
            type="button"
            role="menuitem"
            class="km-layout__opcao"
            data-testid="layout-logout"
            (click)="sair()"
          >
            Sair
          </button>
        </div>
      }
    </div>
  </header>

  @if (sidebarAberta()) {
    <button
      type="button"
      class="km-layout__fundo"
      tabindex="-1"
      aria-label="Fechar menu"
      data-testid="layout-fundo"
      (click)="fecharSidebar(true)"
    ></button>
  }

  <aside #sidebar id="menu-lateral" class="km-layout__sidebar" [class.km-layout__sidebar--aberta]="sidebarAberta()">
    <nav aria-label="Principal">
      @for (g of grupos(); track g.id) {
        <section class="km-layout__grupo" [attr.data-testid]="'menu-grupo-' + g.id">
          <h2 class="km-layout__grupo-titulo">{{ g.rotulo }}</h2>
          <ul class="km-layout__lista">
            @for (i of g.itens; track i.id) {
              <li>
                <a
                  class="km-layout__item"
                  [routerLink]="i.rota"
                  routerLinkActive="km-layout__item--ativo"
                  ariaCurrentWhenActive="page"
                  [attr.data-testid]="'menu-' + i.id"
                  (click)="fecharSidebar()"
                >
                  <i [class]="'bi ' + i.icone" aria-hidden="true"></i>
                  <span class="km-layout__rotulo">{{ i.rotulo }}</span>
                  @if (i.badge !== null) {
                    <span class="km-layout__badge km-num" [attr.data-testid]="'menu-badge-' + i.id">{{ i.badge }}</span>
                  }
                </a>
              </li>
            }
          </ul>
        </section>
      }
    </nav>
  </aside>

  <main id="conteudo" class="km-layout__conteudo" tabindex="-1">
    <router-outlet />
  </main>
</div>

<app-busca-global [atalhos]="atalhos()" />
